import { toast } from "react-toastify";
import { useUserData } from "../../../hooks/useUserData";
import { swingLibraryService } from "../../../services/swingLibrary";
import { subTypeToLevelMap } from "../utils/subTypeToLevelMap";
import { useQuery } from "@tanstack/react-query";

export function useIndicators() {
  const { userData } = useUserData();

  const subscriptionLevel = userData
    ? subTypeToLevelMap(
        userData.role === "admin" ? "admin" : userData.subscriptionType
      )
    : undefined;

  return useQuery({
    enabled: !!subscriptionLevel,
    queryKey: ["indicators", subscriptionLevel],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      try {
        if (!subscriptionLevel) {
          throw new Error("Subscription level is required");
        }
        const res = await swingLibraryService.getIndicators({
          subscriptionLevel,
        });
        return (res ?? []).sort(
          (a, b) => a.category.length - b.category.length
        );
      } catch (error) {
        const msg = error?.message || "Failed to load indicators";
        toast.error(msg);
        return [];
      }
    },
  });
}
